import Sorter from './Sorter';

export default Sorter;
